import type { ReactNode } from "react";

interface UpsellRecommendationsProps {
  /** Where the block is shown — drives which products get priority. */
  context: "cart" | "zemelapis" | "poros";
  /** Extra product ids to hide (e.g. the item just purchased). */
  excludeIds?: string[];
  /** Max number of cards. */
  limit?: number;
  className?: string;
  title?: string;
}

const UpsellRecommendations = (_props: UpsellRecommendationsProps): ReactNode => {
  return null;
};

export default UpsellRecommendations;
